var ARField = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ar-elegant-field",attrs:{"ar-widget-id":"ar-field","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-field"}},[(_vm.label)?_c('div',{staticClass:"u-display-flex"},[(_vm.type === 'primary')?_c('ar-text',{attrs:{"size":"xs","text":_vm.label,"weight":"bold"}}):(_vm.type === 'secondary')?_c('ar-text',{style:({
        color: _vm.$arStyle.color.skyBlueGrey700,
      }),attrs:{"size":"xxs","text":_vm.label,"weight":"bold","letter-spacing":"1px"}}):_vm._e(),_vm._v(" "),(!!_vm.tooltip)?_c('ar-icon',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
        content: _vm.tooltip
      }),expression:"{\n        content: tooltip\n      }",modifiers:{"top":true}}],style:({
        marginLeft: '10px',
      }),attrs:{"name":"tooltip-question-mark","color":_vm.$arStyle.color.skyBlueGrey600,"width":"16px"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.description)?_c('ar-text',{staticClass:"u-margin-top-2",attrs:{"size":"xs","text":_vm.description,"multiple-lines":""}}):_vm._e(),_vm._v(" "),_c('div',{class:[
      'field-content' ],style:({
      marginTop: (_vm.label || _vm.description) ? _vm.fieldContentMarginTop : null,
    })},[(_vm.loading)?_c('ar-skeleton',{staticClass:"loading-mask",attrs:{"level":5}}):_vm._e(),_vm._v(" "),_c('div',{style:({ opacity: _vm.loading ? '0' : null })},[_vm._t("default")],2)],1),_vm._v(" "),_vm._l((_vm.errorMessages),function(errorMsg,errorMsgIndex){return _c('div',{key:errorMsgIndex},[(errorMsg)?_c('ar-state-message',{staticClass:"u-margin-top-2",attrs:{"type":"error","text":errorMsg}}):_vm._e()],1)})],2)},
staticRenderFns: [],
  name: 'ElegantField',
  props: {
    arWidgetMeta: String,
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'primary',
      validator: val => ['primary', 'secondary'].indexOf(val) > -1,
    },
    slotMargin: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `label=${this.label};`,
        `description=${this.description};`,
      ].join('');
    },
    fieldContentMarginTop() {
      if (this.slotMargin) {
        return this.slotMargin;
      }
      return this.type === 'primary' ? '14px' : '10px';
    },
  },
};

export default ARField;
